import { Badge, IconButton } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useContext, useRef, useState } from 'react'
import { MdMenu, MdNotifications } from 'react-icons/md'
import { GlobalContext } from '../App'
import { Avatar, AvatarImage } from '../components/ui/avatar'
import Notificacoes from './Notificacoes'
import OpcoesUsuario from './OpcoesUsuario'
import logo from '../css/logo.png'
import config from '../config.json'

const BUTTON_SIZE = 35

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: (menuWidth) => menuWidth,
    width: (menuWidth) => `calc(100% - ${menuWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  avatar: {
    marginLeft: -10,
  },
  defaultIcon: {
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    display: 'grid',
    placeItems: 'center',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, .1)',
  },
  userButton: {
    borderRadius: '10rem',
    padding: '0 0px 0 0',
  },
  userAvatar: {
    width: BUTTON_SIZE,
    height: BUTTON_SIZE,
    color: 'white',
  },
}))

const Header = () => {
  const { usuarioLogado, menuWidth, dispatch, menuOpen, notificacoes } =
    useContext(GlobalContext)
  const classes = useStyles(menuWidth)

  const user = {
    id: usuarioLogado.id,
    name: usuarioLogado.nome,
    mail: usuarioLogado.email,
    picture: usuarioLogado.foto,
  }

  const openMenu = () => dispatch({ field: 'menuOpen', value: !menuOpen })

  const refNotificacao = useRef()
  const refOpcoesUsuario = useRef()

  const [openNotificacao, setOpenNotificacao] = useState(false)
  const [openOpcoesUsuario, setOpenOpcoesUsuario] = useState(false)
  const toggleOpcoesUsuario = () => setOpenOpcoesUsuario((o) => !o)

  const toggleNotificacoes = () => setOpenNotificacao((o) => !o)

  const [showAlert, setShowAlert] = useState(false)

  return (
    <>
      <div
        color="primary"
        className="fixed bg-[#59a68d] w-full z-[100] p-2 items-center flex justify-between shadow-md"
      >
        <div className="flex items-center ">
          <IconButton onClick={openMenu}>
            <MdMenu color="white" />
          </IconButton>
          <span className="tracking-tight text-md font-medium antialiased text-white">
            {config.titulo}
          </span>
        </div>
        <div className="space-x-7">
          <IconButton
            title="Notificações"
            className={classes.userAvatar}
            onClick={toggleNotificacoes}
            ref={refNotificacao}
            style={{ zIndex: 99 }}
          >
            <Badge
              badgeContent={
                notificacoes?.filter((not) => !not.dtLeitura)?.length || 0
              }
              overlap="rectangular"
              color="primary"
            >
              <MdNotifications />
            </Badge>
          </IconButton>
          <IconButton
            title="Opções"
            onClick={toggleOpcoesUsuario}
            ref={refOpcoesUsuario}
            className={classes.userButton}
          >
            <span className="mr-1 flex-initial text-white font-medium text-sm">
              {user.name}
            </span>
            <Avatar size="1">
              <AvatarImage src={logo} />
            </Avatar>
          </IconButton>
        </div>
      </div>
      <Notificacoes
        zIndex={99}
        {...{ openNotificacao, setOpenNotificacao }}
        ref={refNotificacao}
      />
      <OpcoesUsuario
        {...{ openOpcoesUsuario, setOpenOpcoesUsuario }}
        ref={refOpcoesUsuario}
      />
      {showAlert && (
        <div className="fixed top-[60px] w-full z-[110] bg-red-500 text-white p-3 text-center shadow-md">
          ⚠️ Olá! Renove sua assinatura e continue contando com o suporte e
          benefícios que você já conhece!
          <button
            className="ml-3 underline font-medium"
            onClick={() => setShowAlert(false)}
          >
            Ocultar
          </button>
        </div>
      )}
    </>
  )
}

export default Header
